import React from "react";
import "./styles.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var Sidebar = React.memo(React.forwardRef(function Sidebar(props, ref) {
  return React.createElement("aside", {
    "className": "_6ad07daf _92efe03e _pub-92efe03e",
    "ref": ref,
    "data-testid": props["testId"],
  }, 
    props["children"]
  )
}));
export { Sidebar };


